import { render, staticRenderFns } from "./InfoSingle.vue?vue&type=template&id=de71a324&scoped=true&"
import script from "./InfoSingle.vue?vue&type=script&lang=js&"
export * from "./InfoSingle.vue?vue&type=script&lang=js&"
import style0 from "./InfoSingle.vue?vue&type=style&index=0&id=de71a324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de71a324",
  null
  
)

export default component.exports